export const MIME_TYPES = {
    WEBM:'video/webm',
    MP4:"video/mp4"
}

export const captureThumb = videoTag =>
    new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas')
        canvas.width = videoTag.videoWidth
        canvas.height = videoTag.videoHeight
        canvas.getContext('2d').drawImage(
            videoTag,
            0, // top
            0, // left
            videoTag.videoWidth,
            videoTag.videoHeight
        )
        canvas.toBlob(thumbnail => {
            resolve(thumbnail)
        }, 'image/jpeg')
    })
    